import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketIdentification } from '../../../../state';

interface TitleEditProps {
  required?: boolean;
}

const TitleEdit: React.FC<TitleEditProps> = ({ required = true }) => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateTicketIdentification({ title: event.target.value }));
  };

  return (
    <TextField
      label="Title"
      size="small"
      fullWidth
      required={required}
      value={currentTicket?.identification.title || ''}
      onChange={handleChange}
      placeholder="Enter a descriptive title for the ticket"
    />
  );
};

export default TitleEdit;
